/**
 *
 * UploadFileButton
 *
 */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// icons
import CustomIcons from 'components/CustomIcons';

// components
import UploadMedia from 'containers/UploadMedia';

function UploadFileButton({ name, onAdd, className }) {
  const mainClassNames = classNames('tcf-fb-upload-file', className);

  const renderButton = useMemo(
    () => !!onAdd && (
      <UploadMedia className={mainClassNames} uploadChange={onAdd}>
        <CustomIcons className="tcf-fb-upload-file__icon" type="arrow-right" />
        <span className="tcf-fb-upload-file__label">Ajouter un document</span>
      </UploadMedia>
    ),
    [onAdd],
  );

  return renderButton;
}

UploadFileButton.defaultProps = {
  name: 'media',
  mediaFiles: [],
};
UploadFileButton.propTypes = {
  onAdd: PropTypes.func,
};

export default UploadFileButton;
